import Pusher from 'pusher-js'
const PusherPlugin = {
    pusher:null,
    install: function (app, options) {
        Pusher.logToConsole = import.meta.env.PUSHER_LOG
        try {
            this.pusher = new Pusher(options.pusherApiKey, options.pusherOptions) 
            app.config.globalProperties.$pusher = this.pusher
        } catch (error)
         {
            console.error(error.message)
         }
    }
}

export default PusherPlugin